module.exports = __webpack_public_path__ + "img/LTS_GT.b32541cc.gif";